import React, { useState } from 'react';
import { TextField, Checkbox, FormControlLabel, Button, Typography, Box, FormGroup } from '@mui/material';

const CreateUserGroup = () => {
    const [groupName, setGroupName] = useState('');
    const [accessControl, setAccessControl] = useState({
        createUser: { import: false, export: false, read: false, write: false },
        userFields: { username: false, email: false, mobileno: false, dob: false, age: false },
        yojana: { import: false, export: false, read: false, write: false },
    });

    const handleInputChange = (section, field) => {
        setAccessControl((prev) => ({
            ...prev,
            [section]: {
                ...prev[section],
                [field]: !prev[section][field],
            },
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Group Name:', groupName);
        console.log('Access Control:', accessControl);
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
            {/* Group Name Input */}
            <Box mb={2}>
                <TextField
                    label="Group Name"
                    variant="outlined"
                    fullWidth
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                />
            </Box>

            {/* Access Control Section */}
            <Typography variant="h6">Access Control</Typography>

            {/* Create User Permissions in a Row */}
            <Box mb={2}>
                <Typography variant="subtitle1">Create User</Typography>
                <FormGroup sx={{ display: 'flex', flexDirection: 'row' }}>
                    {['import', 'export', 'read', 'write'].map((field) => (
                        <FormControlLabel
                            key={field}
                            control={
                                <Checkbox
                                    checked={accessControl.createUser[field]}
                                    onChange={() => handleInputChange('createUser', field)}
                                />
                            }
                            label={field}
                        />
                    ))}
                </FormGroup>
            </Box>

            {/* User Fields Permissions in a Row */}
            <Box mb={2}>
                <Typography variant="subtitle1">User Fields</Typography>
                <FormGroup sx={{ display: 'flex', flexDirection: 'row' }}>
                    {['username', 'email', 'mobileno', 'dob', 'age'].map((field) => (
                        <FormControlLabel
                            key={field}
                            control={
                                <Checkbox
                                    checked={accessControl.userFields[field]}
                                    onChange={() => handleInputChange('userFields', field)}
                                />
                            }
                            label={field}
                        />
                    ))}
                </FormGroup>
            </Box>

            {/* Yojana Permissions in a Row */}
            <Box mb={2}>
                <Typography variant="subtitle1">Yojana</Typography>
                <FormGroup sx={{ display: 'flex', flexDirection: 'row' }}>
                    {['import', 'export', 'read', 'write'].map((field) => (
                        <FormControlLabel
                            key={field}
                            control={
                                <Checkbox
                                    checked={accessControl.yojana[field]}
                                    onChange={() => handleInputChange('yojana', field)}
                                />
                            }
                            label={field}
                        />
                    ))}
                </FormGroup>
            </Box>

            {/* Submit Button */}
            <Button type="submit" variant="contained" color="primary">
                Create User Group
            </Button>
        </Box>
    );
};

export default CreateUserGroup;
